import { Platform } from '@angular/cdk/platform';
import { Injectable, OnDestroy } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { PushNotifications, Token, PushNotificationSchema ,PermissionStatus} from '@capacitor/push-notifications';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { SM_CONSTANTS } from '../shared/constants/sm-constants';

@Injectable({
  providedIn: 'root'
})
export class NotificationService implements OnDestroy {
  private unsubscribe$ = new Subject<void>();
  private notificationSubject = new Subject<any>();

  constructor(private angularFireMessaging: AngularFireMessaging,private platform: Platform) {
    // this.initFCMListener();
  }

  async initFCM() {
    if (this.platform.ANDROID || this.platform.IOS) {
      const permissionStatus: PermissionStatus = await PushNotifications.checkPermissions();

      if (permissionStatus.receive !== 'granted') {
        const requestStatus = await PushNotifications.requestPermissions();
        if (requestStatus.receive !== 'granted') {
          console.warn('Notification permission not granted.');
          return;
        }
      }

      await PushNotifications.register();

      // FCM token received
      PushNotifications.addListener('registration', (token: Token) => {
        console.log('FCM Token on fresh load:', token.value);
         localStorage.setItem(SM_CONSTANTS.KEY_FCM_TOKEN, token.value);
      });

      // On notification received while app is open
      PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
        console.log('Push received in foreground', JSON.stringify(notification));
        this.handleNotification(notification);
      });

      // On notification tapped
      PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
        console.log('Notification tapped', notification.notification);
        this.handleNotification(notification.notification);
      });

      PushNotifications.addListener('registrationError', (error: any) => {
        console.error('Registration error:', error);
      });
    }
  }

  private handleNotification(payload: any) {
    if (typeof payload?.data?.misc === 'string') {
      try {
        payload.data.misc = JSON.parse(payload.data.misc);
      } catch (e) {
        console.warn('Failed to parse misc field:', e);
      }
    }
    this.notificationSubject.next(payload);
  }

  getNotificationByType(type: string) {
    return this.notificationSubject.asObservable()
      .pipe(filter((payload: any) => payload?.data?.type === type));
  }

  getAllNotifications() {
    return this.notificationSubject.asObservable();
  }

 

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
